import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

export const UPSERT_SUBMISSION_SURPLUS_LINE = graphql(`
  mutation upsertSubmissionSurplusLine($details: SubmissionInput!) {
    upsertSubmission(details: $details) {
      ... on Submission {
        uuid
        surplusLinesLicenseeInfo
      }
      ... on ValidationErrors {
        message
        code
        errors {
          code
          field
          message
        }
      }
    }
  }
`);

export function useUpsertSubmissionSurplusLineMutation() {
  const [upsertSubmissionSurplusLine, { loading, error, data }] = useMutation(
    UPSERT_SUBMISSION_SURPLUS_LINE
  );

  return {
    upsertSubmissionSurplusLine,
    loading,
    error,
    data,
  };
}
